import { apiFetch } from "../Api/apiClient";
import { criarSessao, lerSessao, limparSessao, salvarSessao } from "./sessao";

const JSON_HEADERS = { "Content-Type": "application/json" };

const CREDENCIAIS_INVALIDAS = "E-mail ou senha inválidos.";
const ERRO_SERVIDOR = "Não foi possível entrar agora. Tente novamente em instantes.";

function erroDeLogin(mensagem, tipo) {
  const erro = new Error(mensagem);
  erro.tipo = tipo;
  return erro;
}

// A api-btk tambem normaliza (trim + minusculas); aqui e para o e-mail
// exibido no menu sair igual ao que o servidor reconheceu.
export const normalizarEmail = (email) => email.trim().toLowerCase();

/**
 * @returns {Promise<{ login: string }>} o usuario da sessao aberta.
 * @throws Error com a mensagem para a tela; tipo "credenciais" no 401.
 */
export async function entrar({ email, senha }) {
  const login = normalizarEmail(email);

  // Sem rede, o apiFetch ja lanca a mensagem de conexao.
  const resposta = await apiFetch("/Auth/Login", {
    autenticar: false,
    method: "POST",
    headers: JSON_HEADERS,
    body: JSON.stringify({ login, password: senha }),
  });

  if (resposta.status === 401 || resposta.status === 422) {
    throw erroDeLogin(CREDENCIAIS_INVALIDAS, "credenciais");
  }

  const sessao = resposta.ok
    ? criarSessao(await resposta.json().catch(() => null), { login })
    : null;
  if (!sessao) throw erroDeLogin(ERRO_SERVIDOR, "servidor");

  salvarSessao(sessao);
  return sessao.usuario;
}

// Revoga a sessao na api-btk e sempre limpa a deste navegador, mesmo sem rede.
// Qualquer refresh token da sessao serve para revogar, inclusive um ja rotacionado.
export async function sair() {
  const sessao = lerSessao();
  try {
    if (sessao) {
      await apiFetch("/Auth/Logout", {
        method: "POST",
        headers: JSON_HEADERS,
        body: JSON.stringify({ refreshToken: sessao.refreshToken }),
      });
    }
  } catch {
    // best effort: o access token restante vence sozinho em ate 15 minutos
  } finally {
    limparSessao();
  }
}
